import { HStack, Text, VStack } from 'native-base';
import Modal from 'ui/components/Modals/Modal';
import Radio from 'ui/components/Radio';
import Select from 'ui/components/v2/inputs/Select';
import { ModalReportLogHoursDownloadProps } from '~/components/ModalReportLogHoursDownload/types';
import { CustomDatePicker } from 'ui/components/DateTimePickers/DatePicker';

import { colors } from 'ui/theme/colors';
import { useModalReportLogHoursDownloadController } from './controller';

const formatOptions = [
  {
    text: 'Excel',
    value: 'XLSX',
  },
  {
    text: 'CSV',
    value: 'CSV',
  },
];

export const ModalReportLogHoursDownload = (
  props: ModalReportLogHoursDownloadProps,
) => {
  const { modalRef } = props;
  const {
    errors,
    control,
    isSubmitting,
    unitOptions,
    handleCloseModal,
    handleSubmit,
    onSubmit,
  } = useModalReportLogHoursDownloadController(props);

  return (
    <Modal
      headerText="Volunteering Activity Report"
      ref={modalRef}
      modalContentMaxW="650"
      leftBtnAction={handleCloseModal}
      leftBtnText="Cancel"
      rightBtnText="Export"
      rightBtnLoading={isSubmitting}
      rightBtnAction={() => handleSubmit(onSubmit)()}
    >
      <VStack space={6}>
        <Text fontSize="md" color="gray.600" mt="4">
          Choose the report’s format and units and click on{' '}
          <strong>Export</strong>. You will receive the generated report at the
          registered email address.
        </Text>

        <Radio
          width="100%"
          flexDirection="row"
          justifyContent="space-between"
          control={control}
          name="format"
          label="File format"
          options={formatOptions}
          checkedColor={colors.primary[600]}
          helperText="Choose the file format of your report."
        />

        <Select.Controlled
          control={control}
          name="units"
          label="Units"
          isMulti
          isRequired
          options={unitOptions}
          errorMessage={errors.units?.message}
          helpText="Choose the units you wish to include in this report."
        />
        <HStack width="100%" alignItems="center" justifyContent="space-between">
          <HStack>
            <CustomDatePicker
              isRequired
              control={control}
              name="startDate"
              label="Start Date"
              dateFormat="dd/MM/yyyy"
            />
          </HStack>
          <HStack>
            <CustomDatePicker
              isRequired
              control={control}
              name="endDate"
              label="End Date"
              dateFormat="dd/MM/yyyy"
            />
          </HStack>
        </HStack>
      </VStack>
    </Modal>
  );
};
